import axiosDefault from 'axios';
import axios from '@axios';
import HelperService from '@/services/HelperService';

const base = '/api/v1/bi-stats';
const helperService = new HelperService();

const { CancelToken } = axiosDefault;

export default {
  prepareFilter(filters) {
    const newFilter = { ...filters };

    if (newFilter.prisonId) { // move single id into multiple as endpoint is now multiple only
      newFilter.prisonIds = [newFilter.prisonId];
      newFilter.prisonId = '';
    }

    return newFilter;
  },
  createCancelToken() {
    const cancel = {
      token: null, // passed to api call
      cancel: null, // func to cancel this token only
    };
    cancel.token = new CancelToken((c => {
      cancel.cancel = c;
    }))

    return cancel;
  },
  getVisitStatsOverview(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/overview${queryString}`);
  },
  getBusiestDay(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/busiest-day-of-week${queryString}`);
  },
  getCancellationReasons(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/cancellation-reasons${queryString}`);
  },
  getVisitorFeedback(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-feedback${queryString}`);
  },
  getVisitorFeedbackLeaderboard(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/visitor-feedback/leaderboard${queryString}`);
  },
  getPrisonerFeedback(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/prisoner-feedback${queryString}`);
  },
  getPrisonerFeedbackLeaderboard(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/prisoner-feedback/leaderboard${queryString}`);
  },
  getVisitorCount(filters, token = null) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-count${queryString}`, {
      cancelToken: token,
    });
  },
  getAdditionalVisitorCount(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-count${queryString}`);
  },
  getBookingSlotStats(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/booking-slots-usage${queryString}`);
  },
  getVisitorCountries(filters, token = null) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-countries${queryString}`, {
      cancelToken: token,
    });
  },
  getVisitorPostcodes(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-postcodes${queryString}`);
  },
  getVisitorDeviceTypes(filters, token = null) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visitor-device-type${queryString}`, {
      cancelToken: token,
    });
  },
  getVisitorTerminatedReasons(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/terminated-reasons${queryString}`);
  },
  getVisitorFeedbackPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/visitor-feedback/paginated/${queryString}`);
  },
  getVisitorFeedbackFullDetails(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/visitor-feedback/paginated/full-details${queryString}`);
  },
  getPrisonerFeedbackPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/prisoner-feedback/paginated${queryString}`);
  },
  getCalls(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/calls${queryString}`);
  },
  getCallsPaginated(filters) {
    // Set filter.before to 23:59 to make date inclusive
    if (filters.before) {
      const before = new Date(filters.before);
      before.setHours(23, 59);
      // eslint-disable-next-line no-param-reassign
      filters.before = before.toISOString();
    }
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/calls/paginated${queryString}`);
  },
  getCallsPaginatedFullDetails(filters) {
    // Set filter.before to 23:59 to make date inclusive
    if (filters.before) {
      const before = new Date(filters.before);
      before.setHours(23, 59);
      // eslint-disable-next-line no-param-reassign
      filters.before = before.toISOString();
    }
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/calls/paginated/full-details${queryString}`);
  },
  getAttendanceStats(filters) {
    const queryString = helperService.buildSearchQueryString(this.prepareFilter(filters));
    return axios.get(`${base}/visit-attendance${queryString}`);
  },
};
